import { supabase } from "@/shared/integrations/supabase/client";
import { assertNotDemo } from "@/shared/lib/userIdUtils";
import type { EditAssetFormData } from "./types";

interface SubmitAssetUpdateArgs {
  assetId: string;
  formData: EditAssetFormData;
  selectedCategoryId: string;
  dynamicAttributes: Record<string, any>;
}

export async function submitAssetUpdate({
  assetId,
  formData,
  selectedCategoryId,
  dynamicAttributes,
}: SubmitAssetUpdateArgs) {
  assertNotDemo("Editing assets");
  const strOrNull = (s: string) => (s.trim() === "" ? null : s.trim());

  // Filter empty string attributes from JSONB
  const cleanedAttributes: Record<string, any> = {};
  Object.entries(dynamicAttributes).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      cleanedAttributes[key] = value;
    }
  });

  const updateData = {
    name: formData.name.trim(),
    manufacturer: strOrNull(formData.manufacturer),
    model_number: strOrNull(formData.model_number),
    serial_number: strOrNull(formData.serial_number),
    status: formData.status as any,
    notes: strOrNull(formData.notes),
    condition_status: formData.condition ? formData.condition.toLowerCase() : null,
    category_id: selectedCategoryId,
    category_attributes: cleanedAttributes,
  };

  const { error } = await supabase
    .from('property_assets')
    .update(updateData)
    .eq('id', assetId);

  if (error) throw error;
}
